import {useAuthStore} from '@/store/auth.js'
export function checkPermission(permission) {
  const { prvi } = useAuthStore()
  if (typeof permission == 'string') {
    return prvi?.includes(permission) ? true : false
  } else if (Array.isArray(permission) && (prvi ?? []).length > 0) {
    return prvi?.some((item) => permission?.includes(item)) ? true : false
  }
}